/**
 * Customer Stories Sidebar Scroll Listener
 * Handles sidebar navigation functionality for customer story pages -
 * highlighting active links and smooth scrolling to sections
 *
 * @return {void}
 */
module.exports = function customerStoriesSidebarScrollListener() {
    const sidebarLinks = document.querySelectorAll('.case-study__sibedar-link a');

    // If no sidebar links, exit early
    if (!sidebarLinks || sidebarLinks.length === 0) {
        return;
    }

    const HEADER_OFFSET = 100;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const id = entry.target.getAttribute('id');

            if (entry.isIntersecting) {
                sidebarLinks.forEach(link => {
                    link.parentElement.classList.remove('case-study__sibedar-link--active');
                });

                const correspondingLink = document.querySelector(`.case-study__sibedar-link a[href="#${id}"]`);
                if (correspondingLink) {
                    correspondingLink.parentElement.classList.add('case-study__sibedar-link--active');
                }
            }
        });
    }, {
        threshold: 0.2,
        rootMargin: `-${HEADER_OFFSET}px 0px -70% 0px`
    });

    sidebarLinks.forEach(link => {
        const targetId = link.getAttribute('href')?.substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
            observer.observe(targetElement);
        }
    });

    sidebarLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();

            const targetId = this.getAttribute('href')?.substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                sidebarLinks.forEach(link => {
                    link.parentElement.classList.remove('case-study__sibedar-link--active');
                });

                this.parentElement.classList.add('case-study__sibedar-link--active');

                const targetPosition = targetElement.getBoundingClientRect().top;
                const startPosition = window.scrollY || document.documentElement.scrollTop;
                const offsetPosition = startPosition + targetPosition - HEADER_OFFSET;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
};